export const LawyerPage = defineAsyncComponent(
  () => import('@/pages/lawyer/ui/@platform/index.vue'),
);
